export default "__VITE_ASSET__D9bQJqIe__";